var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5046_1849)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9999 14.4C6.33127 14.4 6.5999 14.6686 6.5999 15V17C6.5999 17.0412 6.62097 17.13 6.75043 17.2271C6.88319 17.3267 7.09158 17.4 7.33324 17.4H16.6666C16.9082 17.4 17.1166 17.3267 17.2494 17.2271C17.3788 17.13 17.3999 17.0412 17.3999 17V15C17.3999 14.6686 17.6685 14.4 17.9999 14.4C18.3313 14.4 18.5999 14.6686 18.5999 15V17C18.5999 17.4892 18.34 17.9091 17.9694 18.1871C17.602 18.4626 17.1322 18.6 16.6666 18.6H7.33324C6.86765 18.6 6.39776 18.4626 6.03043 18.1871C5.65979 17.9091 5.3999 17.4892 5.3999 17V15C5.3999 14.6686 5.66853 14.4 5.9999 14.4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5756 4.57573C11.81 4.34142 12.1899 4.34142 12.4242 4.57573L15.4242 7.57573C15.6585 7.81004 15.6585 8.18994 15.4242 8.42426C15.1899 8.65857 14.81 8.65857 14.5756 8.42426L11.9999 5.84852L9.42417 8.42426C9.18985 8.65857 8.80995 8.65857 8.57564 8.42426C8.34132 8.18994 8.34132 7.81004 8.57564 7.57573L11.5756 4.57573Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 4.39999C12.3313 4.39999 12.5999 4.66862 12.5999 4.99999V14C12.5999 14.3314 12.3313 14.6 11.9999 14.6C11.6685 14.6 11.3999 14.3314 11.3999 14V4.99999C11.3999 4.66862 11.6685 4.39999 11.9999 4.39999Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.8C17.9647 22.8 22.8 17.9647 22.8 12C22.8 6.03532 17.9647 1.2 12 1.2C6.03532 1.2 1.2 6.03532 1.2 12C1.2 17.9647 6.03532 22.8 12 22.8ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5046_1849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5fb19900cc2cb8151c91ea8c52f6f623.svg";
export { ForwardRef as ReactComponent };